import { formatDateRange } from './utils';

import './CartButton.css'

const CartButton = (props) => {
  const { count, showPopup, dateRange, totalPrice, showModal } = props;

  return (
    <div className='rntr-launcher' onClick={ showPopup } >
      { Boolean(count) && <div className='rntr-count'>{ count }</div> }
      <div className='rntr-cart-button-title'>Rent</div>
    </div>
  )
}

export default CartButton;
